import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import { ErrorResponseType } from '../types';
import { CompetenciesResponse } from '../types/competenciesTypes';

const getCompetenciesCode = import.meta.env.VITE_GET_COMPETENCIES;

export const getCompetencies = async (
  userId: string,
  mode: 'annual-review' | 'profile'
) => {
  const ret: {
    data: CompetenciesResponse | null;
    error: ErrorResponseType | null;
  } = {
    data: null,
    error: null,
  };

  try {
    const { data } = await axios.get(
      `${apiPaths.competencies}/${userId}?mode=${mode}&code=${getCompetenciesCode}`
    );
    if (data) ret.data = (data || null) as CompetenciesResponse;
    else ret.error = errMsgNoData();
  } catch (error) {
    ret.error = errMsg(error);
  }

  return ret;
};
